exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-button{border-right:2px solid #fff;padding-top:6px;padding-bottom:6px;cursor:pointer;font-family:articulatcf-demibold,Open Sans,Lato}.dashboard-button,.dashboard-button-active{background-color:var(--thrivehiregrey);color:var(--corelightcolor)}.dashboard-button-active{background-color:var(--coredarkcolor)}.slide-enter-active{animation:slide-in .3s ease-out forwards}.slide-leave-active{animation:slide-out .3s ease-out forwards}@keyframes slide-in{0%{transform:translateY(-30px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes slide-out{0%{transform:translateY(0);opacity:1}to{transform:translateY(-30px);opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-066ac0c0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/employers/Dashboard.vue
// module id = 632
// module chunks = 0